import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/settings/service-accounts',
)({
  loader: () => ({ breadcrumbTitle: 'Service Accounts' }),
})
